import gql from 'graphql-tag';

export const querySuggestedDokkioTagSynoymnNames = gql`
  query suggestedDokkioTagSynonymNames(
    $dokkioTagName: String!
    $dokkioLabelName: String
    $existingSynonyms: [String!]
  ) {
    suggestedDokkioTagSynonymNames(
      dokkioTagName: $dokkioTagName
      dokkioLabelName: $dokkioLabelName
      existingSynonyms: $existingSynonyms
    )
  }
`;
export default querySuggestedDokkioTagSynoymnNames;
